import React, {useEffect, useRef, useState} from 'react';
import * as Yup from 'yup';
import {toast} from 'react-toastify';
import {useHistory} from 'react-router-dom';
import {Form} from '@unform/web';
import {IoMdCheckmark} from 'react-icons/io';
import DivDiagonal from '../../components/DivDiagonal';
import CustomButton from '../../components/Form/Button';
import Input from '../../components/Form/Input';
import {getProfile, save} from "../../services/User";
import messageTypes from "../../constants/MessagesTypes";
import swal from "@sweetalert/with-react";
import {compressedImage} from "../../utils/compressedImage";
import {
  ProfileWrapper,
  PageHeader,
  ProfileCard,
  CardTitle,
  StyledFormWrapper,
  ContentArea,
  PhotoSection,
  PhotoPreview,
  PhotoInfo,
  ButtonContainer
} from "./styles";

function Profile() {
    const [loading, setLoading] = useState(false);
    const [user, setUser] = useState(false);
    const formRef = useRef(null);
    const history = useHistory();
    const [photo, setPhoto] = useState(null);
    async function handleRegister(data) {
        if (loading) {
            return;
        }
        setLoading(true);
        try {
            formRef.current.setErrors({});
            const schema = Yup.object().shape({
                name: Yup.string().required(messageTypes.REQUIRED_FIELD)
            });
            await schema.validate(data, {
                abortEarly: false,
            });

            const formData = new FormData();
            formData.append('name', data.name);
            if (photo && photo !== '') {
                formData.append('photo', photo);
            }

            const response = await save(formData);

            if (response && response.status === 200) {
                localStorage.setItem('@name', response.data.data.name);
                toast.success(messageTypes.SUCCESS);
                history.push('/dashboard');
            } else {
                toast.error(messageTypes.ERROR_SAVE);
            }
            setLoading(false);
        } catch (err) {
            toast.error(messageTypes.ERROR_SAVE);
            setLoading(false);
            const validationErrors = {};
            if (err instanceof Yup.ValidationError) {
                err.inner.forEach((error) => {
                    validationErrors[error.path] = error.message;
                });
                formRef.current.setErrors(validationErrors);
            }
        }
    }

    useEffect(() => {
        setLoading(true);
        getProfile().then((data) => {
            setUser(data.data.data);
        }).finally(() => setLoading(false));
    }, []);

    function showImage(urlImage) {
        swal(
          {
              showCloseButton: true,
              className: 'img-perfil-modal',
              confirmButtonText: 'Fechar',
              content: <div>
                  <div className={"img-perfil"}>
                      <img src={urlImage} width={'80%'} height={"80%"} alt={'Imagem do perfil'}/>
                  </div>
              </div>,
          }
        );
    }

    return (
        <ProfileWrapper>
            <DivDiagonal/>
            <ContentArea>
                {!loading && (
                    <>
                        <PageHeader>
                            <h1>
                                <i className="fas fa-user"/> Perfil
                            </h1>
                        </PageHeader>
                        
                        <ProfileCard>
                            <StyledFormWrapper>
                                <Form ref={formRef} onSubmit={handleRegister}>
                                    <CardTitle>
                                        <i className="fas fa-edit"/> Alterar usuário
                                    </CardTitle>
                                    
                                    <div className="row mb-3" style={{ marginBottom: '16px' }}>
                                        <div className="col-12">
                                            <Input
                                                type="text"
                                                name="name"
                                                label={'Informe seu nome *'}
                                                defaultValue={user.name}
                                            />
                                        </div>
                                    </div>
                                    
                                    <PhotoSection>
                                        {user && user.urlProfilePhoto && user.urlProfilePhoto !== '' ? (
                                            <PhotoPreview
                                                onClick={() => {
                                                    showImage(`${process.env.REACT_APP_API_ENDPOINT}${user.urlProfilePhoto}`);
                                                }}
                                            >
                                                <img
                                                    src={`${process.env.REACT_APP_API_ENDPOINT}${user.urlProfilePhoto}`}
                                                    alt={"Imagem do perfil"}
                                                />
                                            </PhotoPreview>
                                        ) : (
                                            <PhotoPreview style={{ 
                                                display: 'flex', 
                                                alignItems: 'center', 
                                                justifyContent: 'center',
                                                cursor: 'default'
                                            }}>
                                                <i className="fas fa-user" style={{ fontSize: '48px', color: '#888' }} />
                                            </PhotoPreview>
                                        )}
                                        <PhotoInfo>
                                            <span className="photo-label">
                                                {user && user.urlProfilePhoto && user.urlProfilePhoto !== '' ? 'Alterar imagem do perfil' : 'Imagem do perfil'}
                                            </span>
                                            <input
                                                type="file"
                                                accept="image/*"
                                                onChange={async (event) => {
                                                    const file = await compressedImage(event);
                                                    if (file) {
                                                        setPhoto(file);
                                                    }
                                                }}
                                            />
                                        </PhotoInfo>
                                    </PhotoSection>
                                    
                                    <ButtonContainer>
                                        <CustomButton
                                            className="btn btn-primary text-capitalize font-weight-bold mobile-button"
                                            loading={loading}
                                            type="submit"
                                            startIcon={<IoMdCheckmark/>}
                                            style={{
                                                background: 'linear-gradient(135deg, #f29205 0%, #ff6b35 100%)',
                                                border: 'none',
                                                color: '#ffffff',
                                                padding: '14px 32px',
                                                borderRadius: '10px',
                                                fontWeight: 600,
                                                boxShadow: '0 4px 15px rgba(242, 146, 5, 0.3)',
                                                transition: 'all 0.3s ease'
                                            }}
                                            onMouseEnter={(e) => {
                                                if (!loading) {
                                                    e.currentTarget.style.transform = 'translateY(-2px)';
                                                    e.currentTarget.style.boxShadow = '0 6px 20px rgba(242, 146, 5, 0.4)';
                                                }
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.transform = 'translateY(0)';
                                                e.currentTarget.style.boxShadow = '0 4px 15px rgba(242, 146, 5, 0.3)';
                                            }}
                                        >
                                            Salvar alterações
                                        </CustomButton>
                                    </ButtonContainer>
                                </Form>
                            </StyledFormWrapper>
                        </ProfileCard>
                    </>
                )}
            </ContentArea>
        </ProfileWrapper>
    );
}

export default Profile;
